"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CalciteHtml", {
  enumerable: true,
  get: function get() {
    return _ElementsStyled.CalciteHtml;
  }
});
Object.defineProperty(exports, "CalciteBody", {
  enumerable: true,
  get: function get() {
    return _ElementsStyled.CalciteBody;
  }
});
Object.defineProperty(exports, "CalciteP", {
  enumerable: true,
  get: function get() {
    return _ElementsStyled.CalciteP;
  }
});
Object.defineProperty(exports, "CalciteA", {
  enumerable: true,
  get: function get() {
    return _ElementsStyled.CalciteA;
  }
});
Object.defineProperty(exports, "CalciteH1", {
  enumerable: true,
  get: function get() {
    return _ElementsStyled.CalciteH1;
  }
});
Object.defineProperty(exports, "CalciteH2", {
  enumerable: true,
  get: function get() {
    return _ElementsStyled.CalciteH2;
  }
});
Object.defineProperty(exports, "CalciteH3", {
  enumerable: true,
  get: function get() {
    return _ElementsStyled.CalciteH3;
  }
});
Object.defineProperty(exports, "CalciteH4", {
  enumerable: true,
  get: function get() {
    return _ElementsStyled.CalciteH4;
  }
});
Object.defineProperty(exports, "CalciteH5", {
  enumerable: true,
  get: function get() {
    return _ElementsStyled.CalciteH5;
  }
});
Object.defineProperty(exports, "CalciteH6", {
  enumerable: true,
  get: function get() {
    return _ElementsStyled.CalciteH6;
  }
});
Object.defineProperty(exports, "CalciteOl", {
  enumerable: true,
  get: function get() {
    return _ElementsStyled.CalciteOl;
  }
});
Object.defineProperty(exports, "CalciteUl", {
  enumerable: true,
  get: function get() {
    return _ElementsStyled.CalciteUl;
  }
});
Object.defineProperty(exports, "CalciteLi", {
  enumerable: true,
  get: function get() {
    return _ElementsStyled.CalciteLi;
  }
});
Object.defineProperty(exports, "CalciteFigure", {
  enumerable: true,
  get: function get() {
    return _ElementsStyled.CalciteFigure;
  }
});

var _ElementsStyled = require("./Elements-styled");